import { FilterPartDto, FilterPartEntity } from '../interfaces';
import { Core } from '../../core';

export const FilterPartsStore = Core.Stores.create<FilterPartEntity, FilterPartDto>(
  '/parts/filters',
);
